// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-settings-SettingsPage-module__root--CP5Sw","title":"src-components-page-settings-SettingsPage-module__title--IUO_B"};